import React from 'react';
import { Card, Columns, Column } from '@codeparva/ui-components-library';
import { SectionContentTitle } from './components/sectionContentTitle';
import { SectionContentSubTitle } from './components/sectionContentSubTitle';
import { Text } from './components/text';
export {
  SectionContentTitle,
  SectionContentTitleTypes,
} from './components/sectionContentTitle';
export {
  SectionContentSubTitle,
  SectionContentSubTitleTypes,
} from './components/sectionContentSubTitle';
export { Text, TextTypes } from './components/text';

import { PageTitle } from './components/pageTitle';
import { SectionCardTitle } from './components/sectionCardTitle';
import { SectionTitle } from './components/sectionTitle';
export { PageTitle, PageTitleTypes } from './components/pageTitle';
export { SectionTitle, SectionTitleTypes } from './components/sectionTitle';
export {
  SectionCardTitle,
  SectionCardTitleTypes,
} from './components/sectionCardTitle';
export const TextVariations = () => {
  return (
    <>
      <Columns>
        <Column>
          <Card>
            <PageTitle>This is Page Title</PageTitle>
          </Card>
        </Column>
      </Columns>
      <Columns>
        <Column>
          <Card>
            <SectionTitle>This is Section Title</SectionTitle>
          </Card>
        </Column>
      </Columns>
      <Columns>
        <Column>
          <Card>
            <SectionCardTitle>This is Section Card Title</SectionCardTitle>
          </Card>
        </Column>
      </Columns>
      <Columns>
        <Column>
          <Card>
            <SectionContentTitle>
              This is Section Content Title
            </SectionContentTitle>
          </Card>
        </Column>
      </Columns>
      <Columns>
        <Column>
          <Card>
            <SectionContentSubTitle>
              This is Section Content Sub Title
            </SectionContentSubTitle>
          </Card>
        </Column>
      </Columns>
      <Columns>
        <Column>
          <Card>
            <Text>This is Section Body Text</Text>
          </Card>
        </Column>
      </Columns>
    </>
  );
};
